import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { AddTagFormDialogValues } from "./AddTagFormDialogWrapper";
import ATMCheckbox from "src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox";

type Props = {
  formikProps: FormikProps<AddTagFormDialogValues>;
  onClose: () => void;
  setSaveNextChecked?: any;
  saveNextChecked?: any;
};

const AddTagFormDialog = ({
  formikProps,
  onClose,
  setSaveNextChecked,
  saveNextChecked,
}: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">Add Tags</div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMTextField
            name="tagName"
            value={values?.tagName}
            onChange={(e) => {
              setFieldValue("tagName", e.target.value);
            }}
            label="Tag Name"
            onBlur={handleBlur}
            placeholder="Enter Tag Name"
          />
        </div> 
        <div>
          <ATMCheckbox
            label="Save and Next"
            checked={saveNextChecked}
            onChange={(checked) => {
              setSaveNextChecked(checked);
            }}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default AddTagFormDialog;
